import { memo } from 'react';

interface UploadIconProps {
  size?: number;
  className?: string;
}

const UploadIcon: React.FC<UploadIconProps> = memo(
  ({ size = 17, className = '' }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 17 16"
      fill="none"
      className={className}>
      <path
        d="M16.3198 14.2222C16.3198 14.7111 16.1458 15.1296 15.7976 15.4778C15.4495 15.8259 15.0309 16 14.542 16L2.0976 16C1.60871 16 1.19019 15.8259 0.842046 15.4778C0.493898 15.1296 0.319824 14.7111 0.319824 14.2222L0.319824 8.88889C0.319824 8.63704 0.405009 8.42593 0.575379 8.25556C0.74575 8.08518 0.956861 8 1.20871 8C1.46056 8 1.67168 8.08518 1.84205 8.25556C2.01242 8.42593 2.0976 8.63704 2.0976 8.88889L2.0976 14.2222L14.542 14.2222L14.542 8.88889C14.542 8.63704 14.6272 8.42592 14.7976 8.25555C14.968 8.08518 15.1791 8 15.4309 8C15.6828 8 15.8939 8.08518 16.0643 8.25555C16.2346 8.42592 16.3198 8.63704 16.3198 8.88889L16.3198 14.2222ZM9.20871 3.4L9.20871 9.77778C9.20871 10.0296 9.12353 10.2407 8.95316 10.4111C8.78279 10.5815 8.57168 10.6667 8.31982 10.6667C8.06797 10.6667 7.85686 10.5815 7.68649 10.4111C7.51612 10.2407 7.43094 10.0296 7.43094 9.77778L7.43093 3.4L5.76427 5.06667C5.60131 5.22963 5.40131 5.31111 5.16427 5.31111C4.92723 5.31111 4.71982 5.22963 4.54205 5.06667C4.36427 4.9037 4.27168 4.6963 4.26427 4.44444C4.25686 4.19259 4.34205 3.97778 4.51982 3.8L7.6976 0.622221C7.87538 0.444443 8.08279 0.355555 8.31982 0.355555C8.55686 0.355555 8.76427 0.444443 8.94205 0.622221L12.1198 3.8C12.2976 3.97778 12.3828 4.18889 12.3754 4.43333C12.368 4.67778 12.2754 4.88889 12.0976 5.06667C11.9198 5.22963 11.7087 5.30741 11.4643 5.3C11.2198 5.29259 11.0161 5.20741 10.8532 5.04444L9.20871 3.4Z"
        fill="currentColor"
      />
    </svg>
  ),
);

export { UploadIcon };
